import * as actionTypes from "Redux/Actions/actionTypes";

const initialState = {
  loading: [],
  message: "",
};

const ProgressIndicatorReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.LOADING_START:
      return {
        ...state,
        loading: state.loading.concat({ [action.loading]: true }),
        message: action.message,
      };
    case actionTypes.LOADING_FINISH:
      return {
        ...state,
        loading: state.loading.filter((load) => !load[action.loading]),
      };
    default:
      return state;
  }
};

export default ProgressIndicatorReducer;
